import { WalletWrapper } from "./subs/style";
import { MessageText } from "@/common/elements";
import WalletInfo from "./subs/walletInfo";

import Menucard from "./subs/menucard";
import Table from "@/common/components/Table";
import {
  getTransactionData,
  menuCard,
  transactionTableHeaders,
  transactionTableKeys,
} from "./data";
import { Modal } from "@/common/components/modal";
import AddFund from "./add-fund";
import { useState } from "react";
import PinInput from "./subs/pinInput";

const Wallet = () => {
  const [addFund, setAddFund] = useState<boolean>(false);
  const [inputPin, setInputPin] = useState<boolean>(false);
  const hasWallet = true;
  const handleAdd = () => {
    setAddFund(true);
  };
  return (
    <WalletWrapper>
      {!hasWallet && (
        <MessageText>
          Your wallet request is pending approval, Kindly check back later or
          contact admin.
        </MessageText>
      )}
      {hasWallet && (
        <>
          <WalletInfo accountNumber={8123280394} balance={10} />
          <div className="card-wrapper">
            {menuCard(handleAdd)?.map((card) => (
              <Menucard {...card} />
            ))}
          </div>
          <div className="table-wrapper">
            <Table
              tableHeaders={transactionTableHeaders}
              tableKeys={transactionTableKeys}
              tableData={getTransactionData()}
              tableTitle="transaction History"
              lined
            />
          </div>
          <Modal
            title="Add Fund"
            isOpen={addFund}
            close={() => setAddFund(false)}
          >
            <AddFund
              pin={() => {
                setInputPin(true);
                setAddFund(false);
              }}
            />
          </Modal>
          <Modal
            title="Enter Card PIN"
            isOpen={inputPin}
            close={() => setInputPin(false)}
          >
            <PinInput />
          </Modal>
        </>
      )}
    </WalletWrapper>
  );
};

export default Wallet;
